import Video, { VideoCompressorType, backgroundUpload } from './Video';
import Audio from './Audio';
import Image from './Image';
import {
  getDetails,
  uuidv4,
  generateFilePath,
  getRealPath,
  getVideoMetaData,
} from './utils';

export {
  Video,
  Audio,
  Image,
  backgroundUpload,
  //type
  VideoCompressorType,
  getDetails,
  uuidv4,
  generateFilePath,
  getRealPath,
  getVideoMetaData,
};
export default {
  Video,
  Audio,
  Image,
  backgroundUpload,
  getDetails,
  uuidv4,
  generateFilePath,
  getRealPath,
  getVideoMetaData,
};
